export const NavigationEndpoints = {
  GET_ALL_NAVIGATIONS: '/api/admin/navigations/root',
  GET_NAVIGATION_BY_ID: '/api/admin/navigations/:id',
  CREATE_NAVIGATION: '/api/admin/navigations',
  UPDATE_NAVIGATION: '/api/admin/navigations/:id',
  DELETE_NAVIGATION: '/api/admin/navigations/:id',
  GET_NAVIGATION_PERMISSIONS: '/api/admin/navigations/:id/permissions',
  ASSIGN_NAVIGATION_PERMISSIONS: '/api/admin/navigations/:id/permissions',
  REMOVE_NAVIGATION_PERMISSION: '/api/admin/navigations/:id/permissions/:permissionId',
  GET_SERVICE_METHODS: '/api/admin/navigations/:id/serviceMethods',
  ADD_SERVICE_METHOD: '/api/admin/navigations/:id/serviceMethods',
  BATCH_ADD_SERVICE_METHODS: '/api/admin/navigations/:id/serviceMethods/batch',
  REMOVE_SERVICE_METHOD: '/api/admin/navigations/:id/serviceMethods/:serviceMethodId',
};
